/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface InvoiceControllerGetInvoiceResponse {
  code: number;
  data: {
    /** Invoice 목록 */
    invoices: {
      /** Invoice ID */
      _id: string;
      /** Invoice 번호 */
      invoiceNumber?: string | null;
      /** 병원 ID */
      hospitalID: string;
      /** Order ID */
      orderID?: string | null;
      /** App 목록 */
      apps?: {
        /** App ID */
        _id?: string | null;
        /** App 코드명 */
        appCodeName?: string | null;
        /** App 표시명 */
        appDisplayName?: string | null;
        /** API 호출 횟수 */
        apiCallCount?: number | null;
        /** 할인 전 금액 */
        price?: number | null;
        /** 할인 금액 */
        discountPrice?: number | null;
        /** 할인 후 금액 */
        totalPrice?: number | null;
      }[];
      /** 청구 기간 시작일 */
      periodStartAt?: string | null;
      /** 청구 기간 종료일 */
      periodEndAt?: string | null;
      /** 결제 완료일 */
      paidAt?: string | null;
      /** 통화 단위 */
      currency?: string | null;
      /** 할인 전 합계 금액 */
      originalTotal?: number | null;
      /** 최종 합계 금액 */
      total?: number | null;
      /** Invoice 상태 */
      status: "wait" | "cancel" | "done" | "failed";
      /** 빌링 카드 정보 */
      billingCard?: {
        /** 카드 이름 */
        cardName?: string | null;
        /** 카드 번호 */
        maskedCardNumber?: string | null;
      };
      /** 영수증 URL */
      receiptUrl?: string | null;
      /** 결제 정보 */
      payment: {
        /** 결제 상태 */
        status: "PENDING" | "PAID" | "FAILED" | "CANCELLED" | "PARTIAL_CANCELLED";
        /** 결제 금액 */
        amount: number;
        /** 결제 완료일 */
        paidAt: string | null;
        /** 취소일 */
        cancelledAt: string | null;
        /** 잔여 금액 */
        balanceAmount: number | null;
        /** 취소 내역 */
        cancels?: {
          /** 승인 취소 거래번호 */
          tid: string;
          /** 취소금액 */
          amount?: number | null;
          /** 취소된 시각 ISO 8601 */
          cancelledAt?: string | null;
          /** 취소사유 */
          reason?: string | null;
          /** 취소에 대한 매출전표 확인 URL */
          receiptUrl?: string | null;
          /** 쿠폰 취소금액 */
          couponAmt?: number | null;
        }[];
      };
      /** 세금 포함 최종 합계 금액 */
      taxedTotal: number;
      /** 생성일 */
      createdAt?: string | null;
      /** 수정일 */
      updatedAt?: string | null;
      /** 할인 정책 스냅샷 */
      discountPolicySnapshots?: {
        /** 할인 정책 ID */
        appDiscountPolicyID: string;
        /** 할인 정책 코드명 */
        appCodeName: string;
        /** 할인 율 */
        percentOff?: number | null;
        /** 할인 금액 */
        amountOff?: number | null;
        /** 이전 사용량 */
        usedBefore?: number | null;
        /** 이번 사용량 */
        usedInThis?: number | null;
        /** 잔여 한도 */
        remainingAfter?: number | null;
        /** 적용 시작일 */
        startedAt?: string | null;
        /** 적용 종료일 */
        endedAt?: string | null;
        /** 할인 정책 제목 */
        title?: string | null;
        /** App 표시명 */
        appDisplayName?: string | null;
      }[];
    }[];
    /** 전체 Invoice 개수 */
    total: number;
    /** 현재 페이지 */
    page: number;
    /** 페이지당 항목 수 */
    limit: number;
  };
  message: string;
}

export interface InvoiceControllerGetInvoiceParams {
  /**
   * 페이지 번호 (기본값: 1)
   * @default 1
   */
  page?: number | null;
  /**
   * 페이지당 항목 수 (기본값: 10)
   * @default 10
   */
  limit?: number | null;
}

export type InvoiceControllerGetInvoiceData = InvoiceControllerGetInvoiceResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description Invoice 조회
     *
     * @tags V3-Invoice
     * @name InvoiceControllerGetInvoice
     * @summary Invoice 조회
     * @request GET:/v3/api/invoice
     * @secure
     * @response `200` `InvoiceControllerGetInvoiceData` success
     */
    invoiceControllerGetInvoice: (query: InvoiceControllerGetInvoiceParams, params: RequestParams = {}) =>
      this.request<InvoiceControllerGetInvoiceData, any>({
        path: `/v3/api/invoice`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
